"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getIsLoading = exports.getHref = exports.getIsRouterLink = exports.getActionDescription = exports.getActionName = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _MultiSecondaryButton = _interopRequireDefault(require("../../../button/MultiSecondaryButton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getActionName = function getActionName(action, rows) {
  if (typeof action.name === "function") {
    return action.name(rows);
  }

  return action.name;
};

exports.getActionName = getActionName;

var getActionDescription = function getActionDescription(action, rows) {
  var description = action.description;

  if (!description) {
    return null;
  }

  var _popoverContent = typeof description.title === "function" ? description.title(rows) : description.title;

  var popoverPosition = description.position || "top center";
  return {
    popoverContent: function popoverContent() {
      return _popoverContent;
    },
    popoverPosition: popoverPosition
  };
};

exports.getActionDescription = getActionDescription;

var getIsRouterLink = function getIsRouterLink(isRouterLink, rows) {
  if (typeof isRouterLink === "function") {
    return isRouterLink(rows);
  }

  return isRouterLink;
};

exports.getIsRouterLink = getIsRouterLink;

var getHref = function getHref(href, rows) {
  if (typeof href === "function") {
    return href(rows);
  }

  return href;
};

exports.getHref = getHref;

var getIsLoading = function getIsLoading(isLoading, rows) {
  if (typeof isLoading === "function") {
    return isLoading(rows);
  }

  return !!isLoading;
};

exports.getIsLoading = getIsLoading;

var _default = (0, _mobxReact.observer)(function (props) {
  var className = props.className,
      section = props.section,
      rowContext = props.row,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "section", "row"]);
  var row = rowContext.row;
  var actions = section.config.actions;

  if (actions == null) {
    return null;
  }

  var applicableActions = section.applicableActions(rowContext);

  if (applicableActions.length === 0) {
    return null;
  }

  var buttonActions = applicableActions.map(function (action) {
    var routerLink = action.isRouterLink;
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      text: getActionName(action, [row])
    }, action.apply && {
      onClick: function () {
        var _onClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return action.apply([row]);

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onClick() {
          return _onClick.apply(this, arguments);
        }

        return onClick;
      }()
    }), action.href ? {
      href: getHref(action.href, [row])
    } : null), action.isLoading ? {
      isLoading: getIsLoading(action.isLoading, [row])
    } : null), routerLink ? {
      isRouterLink: getIsRouterLink(routerLink, [row])
    } : null);
  });

  var _applicableActions = (0, _slicedToArray2["default"])(applicableActions, 1),
      firstAction = _applicableActions[0];

  return /*#__PURE__*/_react["default"].createElement(_MultiSecondaryButton["default"], (0, _extends2["default"])({
    actions: buttonActions,
    dropDownPosition: "bottom right"
  }, getActionDescription(firstAction, [row]), otherProps));
});

exports["default"] = _default;